import Vue from "vue";

class Enum {

    public readonly EMPTY_OPTION: string = "_";

    public createSelectDataFromEnum(e: any, translationsPrefix: string = "", addEmptyOption: boolean = false): { label: string; value: string }[] {

        let data = Object.keys(e).map(key => {
            return {
                label: !!translationsPrefix ? Vue.prototype.$localize(translationsPrefix + '-' + e[key]) : e[key],
                value: key
            };
        });

        if (addEmptyOption) {
            data.unshift({label: Vue.prototype.$localize('select-choose'), value: this.EMPTY_OPTION});
        }

        return data;
    }

    public getEnumValue(e: any, value: string): any {

        return e[value as keyof typeof e];
    }

    public getEnumKey<T>(enumObj: T, value: any): string
    {
        const key = Object.keys(enumObj).find(key => enumObj[key as keyof T] === value);
        if (!key) {
            throw new Error(`Value ${value} not found in enum ${JSON.stringify(enumObj)}`);
        }
        return key;
    }
}

export default new Enum();
